import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Modal} from 'react-bootstrap';
import * as Actions from 'actions';

import {MarkerTypesSelector} from 'components'

class NewMarkerModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      name : '',
      icon_key : ''
    }

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit() {
    if(this.state.name == '') {
      this.props.notify({ message: 'Marker types must have a name' });
    }
    else {
      this.setState({name : '', icon_key : ''})
      this.props.sendSocketEmit({new_key : this.state.icon_key, marker_name : this.state.name}, 'set-marker')
      this.props.toggleShowCreateNewMarkerModal(false)
    }
  }

  render() {
    let {marker_types} = this.props;
    let {baseUrl, imagesPath} = this.props.connection;

    return (
      <Modal
        show={this.props.canvassing.show_create_new_marker_modal}
        onHide={() => {this.props.toggleShowCreateNewMarkerModal(false)}}
        >
        <Modal.Header>
          <Modal.Title>Create New Marker</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='col-md-2 col-xs-2'>
              {(() => {
                if(this.state.icon_key !== '') {
                  return <img src={`${baseUrl}${imagesPath}${marker_types[this.state.icon_key]}`} style={{width : '38px'}}/>
                }
                else {
                  return <p>Select a Marker</p>
                }
              })()}
            </div>
            <div className='col-xs-10 col-md-10'>
              <label>Marker Name</label>
              <input
                className='form-control'
                value={this.state.name}
                placeholder='Name'
                onChange={({target}) => {this.setState({name : target.value})}}
                onKeyDown={({key}) => {key == 'Enter' ? this.handleSubmit() : null}}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 col-xs-12'>
              <div className='new-marker-modal-marker-selector'>
                <MarkerTypesSelector
                  marker_types={this.props.marker_types}
                  handleSelectMarker={(key) => {this.setState({icon_key : key})}}
                />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-xs-12 col-md-6'>
              <div className='btn btn-block btn-default' onClick={() => {this.props.toggleShowCreateNewMarkerModal(false)}}>Cancel</div>
            </div>
            <div className='col-xs-12 col-md-6'>
              <div className='btn btn-block btn-primary' onClick={this.handleSubmit}>Save</div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

let mapStateToProps = ({connection, canvassing}) => ({connection, canvassing})

export default connect(mapStateToProps, Actions)(NewMarkerModal)



// WEBPACK FOOTER //
// ./src/browser/components/clients/canvassing/new-marker-modal.js